export default {
  menu: {
    dashboard: "แผงหน้าปัดรถยนต์",
    orderManage: "การจัดการการสั่งซื้อ",
    originalOrders: "คำสั่งเดิม",
    omsOrders: "คำสั่งของ OMS",
    originalAfterSales: "สั่งซื้อหลังการขายต้นฉบับ",
    omsAfterSales: "สั่งซื้อหลังการขาย OMS",
    batchModifyOrder: "ปรับเปลี่ยนคำสั่งเป็นกลุ่ม",
    returnToStorage: "คืนสินค้าในคลังสินค้า",
    orderEntry: "รายการสั่งซื้อ"
  }
};
